<section class="h-100">
  <kl-schedule-send [postDetails]="dialogData?.data?.postDetails" (scheduledDate)="onDateSelection($event)"></kl-schedule-send>
</section>
